import { useState, useRef, useEffect } from "react";

const MobileDropdown = ({ 
  value, 
  onChange, 
  options = [], 
  placeholder, 
  disabled = false,
  displayProperty = "name",
  valueProperty = "id",
  noOptionsText = "No options found"
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getDisplayValue = () => {
    if (!value) return placeholder;
    const selected = options.find(opt => opt[valueProperty] === value);
    return selected ? selected[displayProperty] : placeholder;
  };

  const handleSelect = (optionValue) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
        className={`w-full px-2 py-2 pr-7 border border-[#D2D4D8] rounded-lg text-xs bg-white text-left flex items-center justify-between ${
          disabled ? 'opacity-70 cursor-not-allowed' : ''
        }`}
      >
        <span className={`truncate ${value ? 'text-[#1E1E1ECC]' : 'text-[#1E1E1ECC]'}`}>
          {getDisplayValue()}
        </span>
        <svg
          className="w-3 h-3 text-[#1E1E1ECC] absolute right-2 pointer-events-none flex-shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-[#D2D4D8] rounded-lg shadow-lg max-h-60 overflow-auto">
          {options.length > 0 ? (
            options.map((option) => (
              <button
                key={option[valueProperty]}
                type="button"
                className="w-full px-3 py-2 text-left text-xs hover:bg-gray-50 text-[#1E1E1ECC]"
                onClick={() => handleSelect(option[valueProperty])}
              >
                {option[displayProperty]}
              </button>
            ))
          ) : (
            <div className="px-3 py-2 text-xs text-gray-500">
              {noOptionsText}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MobileDropdown;
